import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useApproveRequisition } from 'modules/ats/hooks/requisitions/useApproveRequisition'
import { useCancelRequisition } from 'modules/ats/hooks/requisitions/useCancelRequisition'
import { AtsRequisition } from 'modules/ats/hooks/requisitions/useRequisition'

import { RejectRequisitionModal } from './RejectRequisitionModal'

interface Props {
  requisition: AtsRequisition
}

export const RequestActions = ({ requisition }: Props) => {
  const {
    access: { id: accessId },
  } = useCurrentSession()
  const { loading: canceling, cancelRequisition } = useCancelRequisition(requisition)
  const { loading: approving, approveRequisition } = useApproveRequisition({
    id: requisition.id,
    approverId: accessId,
  })
  const [showRejectModal, setShowRejectModal] = React.useState(false)

  const onCancel = async () => {
    const result = await cancelRequisition()

    const handledResult = handleResult(result, () => {
      // TODO: Remove this once it's not mandatory
    })

    if (handledResult.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('ats.jobs_requisitions.actions.cancelled'),
        time: 2000,
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.jobs_requisitions.actions.error'),
        time: 2000,
      })
    }
  }

  const onApprove = async () => {
    const result = await approveRequisition()

    const handledResult = handleResult(result, () => {
      // TODO: Remove this once it's not mandatory
    })

    if (handledResult.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('ats.jobs_requisitions.actions.approved'),
        time: 2000,
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.jobs_requisitions.actions.error'),
        time: 2000,
      })
    }
  }

  return requisition.author.id === accessId ? (
    <Button type="negative" onClick={onCancel} disabled={canceling}>
      {i18n.t('ats.jobs_requisitions.requisition_detail.cancel_request')}
    </Button>
  ) : (
    <Box flexDirection="row" justifyContent="flexEnd" gap="s4">
      {showRejectModal && (
        <RejectRequisitionModal
          requisition={requisition}
          onClose={() => setShowRejectModal(false)}
        />
      )}
      <Button type="negative" onClick={() => setShowRejectModal(true)}>
        {i18n.t('ats.jobs_requisitions.requisition_detail.reject_request')}
      </Button>
      <Button type="positive" onClick={onApprove} disabled={approving}>
        {i18n.t('ats.jobs_requisitions.requisition_detail.approve_request')}
      </Button>
    </Box>
  )
}
